const categoriasIVAHardcoded = [
  {
    idCategoriaIVA: 1,
    descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
    abreviaturaCategoriaIVA: "RI",
    codigoAFIPCategoriaIVA: "01",
  },
  {
    idCategoriaIVA: 2,
    descripcionCategoriaIVA: "CONSUMIDOR FINAL",
    abreviaturaCategoriaIVA: "CF",
    codigoAFIPCategoriaIVA: "05",
  },
  {
    idCategoriaIVA: 3,
    descripcionCategoriaIVA: "MONOTRIBUTO",
    abreviaturaCategoriaIVA: "MO",
    codigoAFIPCategoriaIVA: "06",
  },
  {
    idCategoriaIVA: 4,
    descripcionCategoriaIVA: "EXENTO",
    abreviaturaCategoriaIVA: "EX",
    codigoAFIPCategoriaIVA: "04",
  },
  {
    idCategoriaIVA: 5,
    descripcionCategoriaIVA: "IVA EXENTOS EXPORTACION",
    abreviaturaCategoriaIVA: "EE",
    codigoAFIPCategoriaIVA: "00",
  },
  {
    idCategoriaIVA: 6,
    descripcionCategoriaIVA: "IVA NO ALCANZADO",
    abreviaturaCategoriaIVA: "NA",
    codigoAFIPCategoriaIVA: "15",
  },
  {
    idCategoriaIVA: 7,
    descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO SIN IVA",
    abreviaturaCategoriaIVA: "RS",
    codigoAFIPCategoriaIVA: "01",
  },
  {
    idCategoriaIVA: 8,
    descripcionCategoriaIVA: "CLIENTE DEL EXTERIOR",
    abreviaturaCategoriaIVA: "CE",
    codigoAFIPCategoriaIVA: "09",
  },
];

const getCategoriasIVA = async () => {
  return categoriasIVAHardcoded;
};

const categoriasIVA = {
  getCategoriasIVA,
};

export default categoriasIVA;
